import axiosInstance from "../../scenes/utils/axiosInstance";
import { API_ENDPOINTS } from "../../config/api";

export default class FileService {
 createFile = async (data) =>{
    try{
        const response = await axiosInstance.post(API_ENDPOINTS.FILES.CREATE, data);
        return response.data ;
    }
    catch(error){
        console.log("Bir hata oluştu.createFile")
    }
 }
 getAllFiles = async (options = {})=>{
    try{
        const response = await axiosInstance.get(API_ENDPOINTS.FILES.ALL, options);
        if (options.withMeta) {
            return { data: response.data, headers: response.headers };
        }
        return response.data;
    }catch(error){
        console.log("Bir hata oluştu.getAllFiles") 
    }
 }
 exportFilesExcel = async (filters = {}) => {
    const response = await axiosInstance.get(API_ENDPOINTS.FILES.EXPORT_EXCEL, {
        params: filters,
        responseType: "blob",
    });
    return response;
 }
 getFileInfo = async (fileID)=>{
    try{
        const response = await axiosInstance.get(API_ENDPOINTS.FILES.BY_ID(fileID))
        return response.data;
    }catch(error){
        console.log("Bir sorun oluştu.getFileInfo", error);
        throw error; // Hata fırlat ki File.jsx'te yakalanabilsin
    }  
 }
 deleteFile = async (fileId)=>{
    try{
        const response = await axiosInstance.delete(API_ENDPOINTS.FILES.DELETE(fileId));
        return response.data
    }catch (error) {
        console.error("Bir sorun oluştu:", error.response?.data || error.message);
        throw error;
    }
 }
 
 copyFile = async (fileId, newFileName) => {
    try {
        const response = await axiosInstance.post(API_ENDPOINTS.FILES.COPY(fileId), { newFileName });
        return response.data;
    } catch (error) {
        console.error("Copy file error:", error.response?.data || error.message);
        throw error;
    }
 }

 updateFile = async (fileId, updateData) => {
    try {
        const response = await axiosInstance.put(API_ENDPOINTS.FILES.UPDATE(fileId), updateData);
        return response.data;
    } catch (error) {
        console.error("Update file error:", error.response?.data || error.message);
        throw error;
    }
 }
}